<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Ingresa tu Nombre y Apellido *'"
            />
            <div class="form__field">
              <label
                for="nombre"
              ><v-icon
                name="user"
                scale="1"
                style="margin: 1px 1px 0"
              /></label>
              <input
                id="nombre"
                ref="nombre"
                v-model="nombre"
                autocomplete="off"
                type="text"
                name="nombre"
                value=""
                placeholder="Nombre"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('email')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('nombre', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Ingresa tu email *'"
            />
            <div class="form__field">
              <label
                for="email"
              ><v-icon
                name="envelope"
                scale="1"
                style="margin-top: 2px"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('telefono')"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @change="cleanSpecialChars('email', 'email')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono de contacto *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 1px 2px 0 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('npedido')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'N° Pedido *'"
            />
            <div class="form__field">
              <label
                for="npedido"
              ><v-icon
                name="file"
                scale="1"
                style="margin: 1px 2px 0 4px"
              /></label>
              <input
                id="npedido"
                ref="npedido"
                v-model="npedido"
                autocomplete="off"
                type="text"
                name="npedido"
                value=""
                placeholder="1234567891234-0"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('comentario')"
                @keypress="keyPressCheckSpecialChars($event, 'orderNumber')"
                @change="cleanSpecialChars('npedido', 'orderNumber')"
              >
            </div>
            <!-- TEXTAREA -->

            <div class="form_label">
              Solicitud *
            </div>
            <div class="score-comments">
              <textarea
                id="comentario"
                ref="comentario"
                v-model="comentario"
                style="white-space: pre-line"
                placeholder="Escribe tu solicitud..."
              />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import formUtils from '../../formUtils'
import utils from '../../utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      if (this.telefono.length <= 8) {
        this.errormsg = 'Debes ingresar teléfono válido'
        return
      }
      if (!this.npedido || this.npedido === '') {
        this.errormsg = 'Debes ingresar N° de pedido'
        return
      }
      if (!this.comentario) {
        this.errormsg = 'Debes ingresar comentario'
        return
      }
      const dataToSend = {
        form: 'KrossWrongProductForm',
        evento: 'sentClick',
        data: {
          type: 'kross-form-wrong-product-confirm',
          fields: {
            firstname: this.nombre,
            email: this.email,
            npedido: this.npedido,
            phone: this.telefono,
            comment: this.comentario
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'KrossWrongProductForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      comentario: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      nombre: '',
      email: '',
      telefono: '',
      npedido: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'KrossWrongProductForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log('e.dato:', e.dato)
        this.title = e.dato.title ? e.dato.title : 'Kross Producto Erróneo'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''

        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
        this.npedido = this.npedido || ''
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
  height: 335px;
}
</style>
